import { apiClient } from './client';

export const booksApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getBookById: builder.mutation<any, { bookId: string; isbn: string }>({
            query: ({bookId, isbn}) => {
                    if(isbn && isbn.trim()) return { url: `api/books/${bookId}?isbn=${isbn}` }
                    else return { url: `api/books/${bookId}` }
            },
            transformResponse: (response: any) => response,
        }),
        getClassSubjects: builder.query<
            any,
            {
                school_id: number | null;
                academic_year_id: number;
                board_id: number;
                product: string;
            }
        >({
            query: ({ school_id, academic_year_id, board_id, product }) => {
                return {
                    url: `api/classSubjects?school_id=${school_id}&academic_year_id=${academic_year_id}&board_id=${board_id}&product=${product}`
                }
            },
        }),
        // TODO: https://redux-toolkit.js.org/rtk-query/usage/mutations#defining-mutation-endpoints
        getBooks: builder.mutation<
            any,
            {
                academic_year_id: number;
                board_id: number;
                class_subjects: any[];
                platform: string;
            }
        >({
            query: (body) => ({
                url: 'api/books',
                method: 'POST',
                body: body,
            }),
        }),
        getResourcesById: builder.mutation<
            any,
            {
                resource_id: string;
                resource_path: string;
                book_uri: string;
                bookId: string;
                historyrequired: boolean;
                type: string;
            }
        >({
            query: ({
                resource_id,
                resource_path,
                book_uri,
                bookId,
                historyrequired,
                type,
            }) => ({
                url: `api/books/resources?historyrequired=${historyrequired}&type=${type}`,
                method: 'POST',
                body: { resource_id, resource_path, book_uri, bookId }, // Excluding historyrequired from body
            }),
        }),
        getBookChapters: builder.query<any, any>({
            query: (bookId) => {
                return {
                    url: `api/books/${bookId}/chapters`
                }
            },
            transformResponse: (response: any) => response,
        }),
        getBookChapterResources: builder.mutation<
            any,
            {
                usm_id: string;
                first_page: string;
                last_page: string;
                book_name: string;
                book_id: string;
            }
        >({
            query: (body) => ({
                url: `api/books/chapter/resources`,
                method: 'POST',
                body: body,
            }),
        }),
    }),
});

export const {
    useGetBookByIdMutation,
    useGetClassSubjectsQuery,
    useGetBooksMutation,
    useGetResourcesByIdMutation,
    useGetBookChaptersQuery,
    useGetBookChapterResourcesMutation,
} = booksApi;
